import areRangesOverlapping from 'date-fns/are_ranges_overlapping';

export const isGuideUnavailable = (startDate, endDate, upcomingTreks) => {
  if (!upcomingTreks) return false;

  return upcomingTreks.some(trek => areRangesOverlapping(
    new Date(startDate),
    new Date(endDate),
    new Date(trek.startDate),
    new Date(trek.endDate),
  ));
};

const platformLinkPrefix = {
  facebook: '',
  instagram: '',
  youtube: '',
  whatsapp: 'https://api.whatsapp.com/send?phone=',
  viber: 'viber://chat?number=',
  website: '',
}

export function getPlatformLink(url, platform) {
  if (!url) return '';
  return platformLinkPrefix[platform] + url;
}
